// src/admin/RequireAdmin.jsx
// Sin restricciones: renderiza el contenido del panel sin verificar rol o sesión
import React from 'react';

export default function RequireAdmin({ children }) {
  return children;
}
